<template>
    <v-content class="mainView">
        <router-view></router-view>
    </v-content>
</template>

<script>

export default {
    components: {
    },
    data: () => ({
    })
};
</script>
